import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { CommonModal, FormDrawer, Table } from "components";
import { useRoleManager } from "services/useRoleManager";
import { FormProvider, useForm } from "react-hook-form";
import PaymentStatusesForm from "./components/PaymentStatusForm";
import { useAppDispatch } from "store/storeHooks";
import { setOpenDrawer } from "components/elements/formDrawer/formdrawer.slice";
import { useApiMutation } from "hooks/useApi/useApiHooks";
import { usePaymentStatusColumns } from "./paymentStatus.columns";
import { IPaymentStatus } from "./types";

export interface IPaymentStatusProps {}

export const PaymentStatus: FC<IPaymentStatusProps> = ({}) => {
  const { t } = useTranslation();
  const columns = usePaymentStatusColumns();
  const hasAccess = useRoleManager();
  const [remove, setRemove] = useState<string>();
  const [edit, setEdit] = useState<IPaymentStatus | null>(null);
  const formStore = useForm<IPaymentStatus>();
  const dis = useAppDispatch();

  const { mutateAsync, status } = useApiMutation(
    `payment-status/${remove}`,
    "delete",
    {}
  );

  function resetForm() {
    setEdit(null);
    formStore.reset({
      _id: undefined,
      color: undefined,
      text: undefined,
    });
  }

  return (
    <FormProvider {...formStore}>
      <Table
        isGetAll
        onAddButton={
          hasAccess("managePaymentStatus")
            ? () => {
                dis(setOpenDrawer(true));
              }
            : undefined
        }
        dataUrl="/payment-status/all"
        columns={columns}
        onDeleteColumn={
          hasAccess("managePaymentStatus")
            ? (data: IPaymentStatus) => {
                setRemove(data._id);
              }
            : undefined
        }
        onEditColumn={
          hasAccess("managePaymentStatus")
            ? (data: IPaymentStatus) => {
                dis(setOpenDrawer(true));
                setEdit(data);
              }
            : undefined
        }
        title={t("TABLE.PAYMENT_STATUS")}
      />
      <FormDrawer
        FORM_ID="add-payment-status"
        formItemTitle={
          edit
            ? t("general.edit_payment_status")!
            : t("general.payment_status")!
        }
        onClose={resetForm}
        isEditing={!!edit}
      >
        <PaymentStatusesForm
          formStore={formStore}
          edit={edit as IPaymentStatus}
          resetForm={resetForm}
        />
      </FormDrawer>

      <CommonModal
        title={t("general.realy_delete")!}
        open={!!remove}
        setOpen={setRemove}
        onSave={() =>
          mutateAsync({}).then(() => {
            setRemove(undefined);
          })
        }
        status={status}
      />
    </FormProvider>
  );
};
